import { ActionIcon, Menu } from '@mantine/core';
import { IconDots, IconPencil, IconTrashX } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface ActionMenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
}

const ActionMenu: FC<ActionMenuProps> = ({ onDelete, onEdit }) => {
  const { t } = useTranslation();
  return (
    <Menu shadow="md">
      <Menu.Target>
        <ActionIcon
          color="gray.5"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <IconDots size="1.125rem" />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        {onEdit && (
          <Menu.Item
            leftSection={<IconPencil size={14} />}
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            {t('edit')}
          </Menu.Item>
        )}
        {onDelete && (
          <Menu.Item
            color="red"
            leftSection={<IconTrashX size={14} />}
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            {t('delete_btn')}
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};

export default ActionMenu;
